import LeftNav from "../components/LeftNav";
import Header from "../components/LoanUnderwrite/Header";
import UserService from "../services/UserService";
import React, { useState, useEffect } from "react";
import axios from "axios";

const serverConfig = require("../config/server.js");

const CreditConfig = () => {

    const [token, setToken] = useState(null);
    const [company, setCompany] = useState("");
    

    const getToken = () => {
        console.log(sessionStorage.getItem('token'));
        let jwt = UserService.getToken();
        axios.post(serverConfig.api_base_url + "user_get_token",{jwt:jwt})
        .then(response=>{
        console.log('user_get_token response', response);
        if(response.data.status === 200){
            sessionStorage.setItem('token', response.data.token);
            setToken(response.data.token);
        } else if(response.data.status >= 400 && response.data.status <= 499){
            alert(response.data.message);
        } else if(response.data.jwt_validation === 'fail') {
            // handleLogout();
        }
        })
        .catch(err=>console.log("error is",err));
    }
    
    return (
        <>
            <div className="main-wrapper"></div>
            <Header token={token} setCompany={setCompany} />
        </>
    )
}

export default CreditConfig;